import React from 'react'

const Person = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="30"
      viewBox="0 0 13 30"
    >
      <g>
        <g>
          <g>
            <path fill="#3a3a3a" d="M7 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
          </g>
          <g>
            <path
              fill="#3a3a3a"
              d="M8.125 9h-3.25C2.188 9 0 11.078 0 13.632v5.105c0 .824.482 1.565 1.258 1.933l1.164.552c.11.053.178.16.178.277v6.34C2.6 29.03 3.62 30 4.875 30h3.25c1.254 0 2.275-.97 2.275-2.162v-6.34c0-.117.069-.223.18-.276l1.163-.552c.775-.368 1.257-1.11 1.257-1.933v-5.105C13 11.078 10.812 9 8.125 9z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Person
